import { Accordion } from '@sunwebgroup/ui-components/uds'
import { isEmpty } from 'ramda'
import * as React from 'react'
import { useIntl } from '@/intl'
import { useSelectFilter } from '@/scopes/search/search/domain/hooks'
import {
  SkiAreaMinimumAltitudeMetersFilter,
} from '@/scopes/search/search/pages/SearchPage/components/Filters/SkiAreaFilters/SkiAreaMinimumAltitudeMetersFilter'
import {
  SkiAreaSlopeKmsFilter,
} from '@/scopes/search/search/pages/SearchPage/components/Filters/SkiAreaFilters/SkiAreaSlopeKmsFilter'
import { FilterGroupProps } from '../../types'

export function SkiAreaFilters({ defaultOpen }: FilterGroupProps) {
  const intl = useIntl()
  const { options: skiAreaMinAltitudeOptions } = useSelectFilter('SkiAreaMinimumAltitudeMeters')
  const { options: skiAreaSlopeKmsOptions } = useSelectFilter('SkiAreaSlopeKms')

  if (isEmpty(skiAreaMinAltitudeOptions) && isEmpty(skiAreaSlopeKmsOptions)) {
    return null
  }
  return (
    <Accordion.Item
      title={intl.formatMessage({ id: 'search_filter_ski_area_label' })}
      defaultOpen={defaultOpen}
      data-qa="ski-area-filters"
    >
      <SkiAreaSlopeKmsFilter />
      <SkiAreaMinimumAltitudeMetersFilter />
    </Accordion.Item>
  )
}
